import {useAuthStore} from '@common-web/stores/authStore';
import type {ClientFeaturesShape} from '@common/menuFlags';

/**
 * Tenant-level feature flags for the signed-in user, or `null` when no tenant
 * profile carries them. A user signs in with exactly one of a client, broker,
 * or group profile — all three surface the same `Client.features` shape — so
 * we fall through them in that order. Use this where unavailable features must
 * fail closed (e.g. default-deny menu filtering).
 */
export function useClientFeaturesOrNull(): ClientFeaturesShape | null {
  const user = useAuthStore((state) => state.user);
  return (
    user?.clientProfile?.features ??
    user?.brokerProfile?.features ??
    user?.groupProfiles?.[0]?.features ??
    null
  );
}

/** Tenant-level feature flags for the signed-in user, `{}` when unavailable. */
export function useClientFeatures(): ClientFeaturesShape {
  return useClientFeaturesOrNull() ?? {};
}
